import React, { useState } from 'react';

import Button from '../../../themed/button';
import Conditional from '../../../common/conditional';

import { concatClassNames } from '../../../../utils/utilities';
import classNames from './style.module.scss';

interface CustomNewItemProps {
	children: React.ReactNode | React.ReactNode[];
	label: string;
}

const CustomNewItem: React.FC<CustomNewItemProps> = ({ children, label }) => {
	const [isOpen, setOpen] = useState(false);

	return (
		<div className={classNames.accordionItem}>
			<div className={concatClassNames([classNames.accordionItemHeader])}>
				<div>{label}</div>

				<Button
					label={isOpen ? 'Close' : 'Expand'}
					icon={isOpen ? 'x' : 'plus'}
					onClick={() => setOpen((prev) => !prev)}
				/>
			</div>

			<Conditional isVisible={isOpen}>
				<div className={classNames.accordionItemBody}>
					{children}
				</div>
			</Conditional>
		</div>
	);
};

export default CustomNewItem;
